module.exports = __webpack_public_path__ + "img/excel-icon.186b63cf.svg";